<section class="w-full lg:py-25 py-10">
  <div class="flex flex-col items-center w-full px-4 lg:px-0 container gap-6 lg:gap-15">
    <!-- 헤더 - 모바일과 PC 레이아웃 분리 -->
    <div class="flex flex-col gap-4 items-center">
      <div class="flex flex-col gap-3 text-center">
        <p class="font-extrabold text-sm lg:text-lg text-gradient-primary bg-clip-text text-transparent">
          BUSINESS OBJECTIVE
        </p>
        <h1 class="text-2xl lg:text-4xl lg:leading-14 text-zinc-800">
          창조적인 솔루션, <span class="font-extrabold">함께하는 파트너</span><br />글로벌 기준의 혁신
        </h1>
      </div>

      <p class="text-sm text-zinc-500 font-medium text-center lg:text-lg">
        창의적인 아이디어와 통합 마케팅 솔루션으로 브랜드의 가치를 높이고, 전략적 컨설팅을 통해 지속 가능한 성장을
        이끌어갑니다.
      </p>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-3 gap-25">
      <div class="flex flex-col items-center gap-6">
        <img src="/home/business1.svg" alt="business image 1" class="size-15" />
        <div class="flex flex-col gap-3 text-center">
          <p class="text-zinc-800 text-xl font-extrabold">Creativity & Promotion</p>
          <p class="font-medium text-zinc-500">창의적인 기획과 효과적인 프로모션</p>
        </div>
      </div>
      <div class="flex flex-col items-center gap-6">
        <img src="/home/business2.svg" alt="business image 2" class="size-15" />
        <div class="flex flex-col gap-3 text-center">
          <p class="text-zinc-800 text-xl font-extrabold">One-Stop Marketing</p>
          <p class="font-medium text-zinc-500">기획부터 실행까지 통합된 마케팅 서비스</p>
        </div>
      </div>
      <div class="flex flex-col items-center gap-6">
        <img src="/home/business3.svg" alt="business image 3" class="size-15" />
        <div class="flex flex-col gap-3 text-center">
          <p class="text-zinc-800 text-xl font-extrabold">Consulting & Branding</p>
          <p class="font-medium text-zinc-500">전략 컨설팅과 브랜드 가치 구축</p>
        </div>
      </div>
    </div>
  </div>
</section>
